import { Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { LucideChevronRight, LucideDynamicIcon } from '@lucide/angular';
import { NgpBreadcrumbList, NgpBreadcrumbs } from 'ng-primitives/breadcrumbs';
import { TextDirective } from '../../typography/text.directive';

export type Breadcrumb = {
  label: string;
  href: string;
  /** When set, clicking this breadcrumb runs the action instead of navigating. */
  action?: () => void;
};

@Component({
  selector: 'nav[joii-breadcrumbs]',
  imports: [NgpBreadcrumbList, TextDirective, LucideDynamicIcon, RouterLink],
  hostDirectives: [{ directive: NgpBreadcrumbs }],
  template: `
    <ol ngpBreadcrumbList>
      @for (breadcrumb of breadcrumbs(); track $index) {
        <li ngpBreadcrumbItem>
          @if ($index < breadcrumbs().length - 1) {
            @if (breadcrumb.action) {
              <a
                class="link"
                joii-text
                [size]="3"
                [color]="$index < breadcrumbs().length - 1 ? 'tint2' : 'inline-link'"
                (click)="breadcrumb.action!()"
                >{{ breadcrumb.label }}</a
              >
            } @else if (isExternalHref(breadcrumb.href)) {
              <a
                class="link"
                joii-text
                [size]="3"
                [color]="$index < breadcrumbs().length - 1 ? 'tint2' : 'inline-link'"
                [href]="breadcrumb.href"
                >{{ breadcrumb.label }}</a
              >
            } @else {
              <a
                class="link"
                joii-text
                [size]="3"
                [color]="$index < breadcrumbs().length - 1 ? 'tint2' : 'inline-link'"
                [routerLink]="routerLinkCommands(breadcrumb.href)"
                >{{ breadcrumb.label }}</a
              >
            }
          } @else {
            <span joii-text [size]="3" color="inline-link" class="link">{{ breadcrumb.label }}</span>
          }
        </li>
        @if ($index < breadcrumbs().length - 1) {
          <div joii-text [size]="3" color="tint2">
            <svg [lucideIcon]="chevronRight" [size]="20" />
          </div>
        }
      }
    </ol>
  `,
  styleUrl: './breadcrumbs.component.css',
})
export class BreadcrumbsComponent {
  breadcrumbs = input<Breadcrumb[]>([]);
  chevronRight = LucideChevronRight;

  isExternalHref(href: string): boolean {
    return /^(https?:|mailto:|tel:)/i.test(href);
  }

  routerLinkCommands(href: string): string[] {
    const path = href.split(/[?#]/)[0];
    if (path.startsWith('/')) {
      return ['/', ...path.split('/').filter(Boolean)];
    }
    return path.split('/').filter(Boolean);
  }
}
